// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_3CVqf","visuallyhidden":"_2n9so","hide-text":"_1EdUg","center":"_1dnMF","noprint":"vgkRP","root":"_18FzH","image":"_3ROuS","alternateImagePosition":"SSrT0","content":"_1mXCu","label":"_16TvN"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-teaser-small/styles/default.scss
 ** module id = 1022
 ** module chunks = 2
 **/